import { render, staticRenderFns } from "./NamesReport.vue?vue&type=template&id=894c9fca&scoped=true"
import script from "./NamesReport.vue?vue&type=script&lang=js"
export * from "./NamesReport.vue?vue&type=script&lang=js"
import style0 from "./NamesReport.vue?vue&type=style&index=0&id=894c9fca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894c9fca",
  null
  
)

export default component.exports